import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from './TextInput.styled';

export class TextInput extends Component {
  state = {
    value: this.props.value
  };

  onChangeHandler = event => {
    this.setState({ value: event.target.value });
  };

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    let { maxLength, alt, placeholder, tabIndex, onBlur, name, disabled } = this.props;
    let { value } = this.state;

    return (
      <Input
        key={name}
        type="text"
        value={value}
        tabIndex={tabIndex}
        placeholder={placeholder}
        aria-label={placeholder}
        alt={alt}
        name={name}
        maxLength={maxLength}
        disabled={disabled}
        onChange={this.onChangeHandler}
        onBlur={onBlur}
        title={value || placeholder}
      />
    );
  }
}

TextInput.propTypes = {
  name: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  tabIndex: PropTypes.number,
  alt: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
};

TextInput.defaultProps = {
  alt: 'Input value please',
  placeholder: 'Type your answer',
  maxLength: 255
};

export default TextInput;
